export default __webpack_public_path__ + "20bd5638e7d33f817994ab8630a64576.png";